// extracted by mini-css-extract-plugin
export default {"IconButtonBox":"IconButton_IconButtonBox__Jx4+x","active":"IconButton_active__9qgln","icon":"IconButton_icon__JQYkY","iconBox":"IconButton_iconBox__u3-B6"};